import React from "react";
import { ParagraphSkeleton } from "@features/skeletons/common/ParagraphSkeleton/ParagraphSkeleton";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const AdditionalServiceSkeleton: React.FC = () => (
  <div className="flex flex-col items-center gap-5 lg:flex-row lg:items-start lg:gap-6">
    <div className="w-full max-w-[350px] overflow-hidden rounded-xl border border-[#DEDEDE] bg-base-white shadow-sm">
      <div className="relative h-[191px] w-full">
        <Skeleton variant="rectangular" className="h-[191px]" />
      </div>
      <div className="p-6">
        <div className="flex flex-col gap-2">
          <Skeleton className="w-[120px] text-sm" />
          <Skeleton className="w-[100px] text-xl leading-6" />
        </div>
      </div>
      <div className="flex flex-col gap-4 border-t border-[#DEDEDE] px-6 py-5">
        <Skeleton variant="rounded" className="h-11" />
        <Skeleton variant="rounded" />
      </div>
    </div>
    <div className="w-full max-w-[350px] overflow-hidden rounded-xl border border-[#DEDEDE] bg-base-white shadow-sm lg:max-w-full">
      <div className="border-b border-[#DEDEDE] p-6">
        <Skeleton className="w-[130px] text-lg" />
      </div>
      <div className="p-6">
        <ParagraphSkeleton />
      </div>
    </div>
  </div>
);
